// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2B5io","ranges":"BmiRanges_ranges__3JId4"};